import * as React from "react";
import cn from "classnames";

import Styles from "./TextInput.module.scss";

interface CustomInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  value?: string;
  placeholder?: string;
  className?: string;
}

export const TextInput: React.FC<CustomInputProps> = ({ label, value, placeholder, className, ...rest }) => {
  return (
    <input
      id="text-input"
      type="text"
      inputMode="search"
      placeholder={placeholder}
      aria-label={placeholder}
      className={cn(Styles.input, className)}
      {...rest}
    />
  );
};

export default TextInput;
